/**
 * Custom hook to parse a query string
 * @returns URLSearchParams
 */

// using window.location here because of hash router
export const useQuery = (): URLSearchParams =>
  new URLSearchParams(window.location.search);
